import { slugify, QueryString } from "@grandvisionhq/utils";
const createBreadcrumbs = (store, rootLabel, storesRoute) => {
  if (!storesRoute) {
    console.error(
      "createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found"
    );
    return [];
  }
  return [
    {
      name: "Home",
      url: "/"
    },
    {
      name: rootLabel,
      url: storesRoute
    },
    {
      name: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbName : store.town,
      url: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbSlug : `${storesRoute}?search=${store.town}`
    },
    {
      name: `${store.name}`,
      url: `${storesRoute}/${store.slug}`
    }
  ];
};
const getBookAppointmentUrl = (bookAppointmentUrl, options) => (store) => {
  const { globalStoreId, code } = store;
  let result = bookAppointmentUrl;
  if (options?.alternativeUrl?.length && options?.alternativeUrlStores?.includes(globalStoreId)) {
    result = options.alternativeUrl;
    if (options?.paddedLength) {
      const storeId = String(code).padStart(options.paddedLength, "0");
      result = `${result}?storeId=${storeId}`;
    } else {
      result = `${result}?storeId=${code}`;
    }
    return result;
  }
  if (options?.paddedLength) {
    const storeId = globalStoreId.padStart(options.paddedLength, "0");
    result = `${result}?storeId=${storeId}`;
  } else {
    result = `${result}?storeId=${globalStoreId}`;
  }
  return result;
};
const getStoreDetailUrl = (storesListUrl) => (store) => `${storesListUrl}/${slugify(store.town)}/${store.slug ?? store.globalStoreId}`;
const areServicesAvailable = (store, services) => !store?.servicesNotAvailable?.some((notAvailable) => services.includes(notAvailable));
const isEqualStores = (a, b) => {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  const codes = a.map(({ globalStoreId }) => globalStoreId);
  for (const store of b) {
    const index = codes.indexOf(store.globalStoreId);
    if (index === -1) {
      return false;
    }
    codes.splice(index, 1);
  }
  return true;
};
const removeEmptyValues = (queryParams) => Object.entries(queryParams).filter(([, value]) => value !== null && value !== void 0 && value !== "").reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
const getStoreFinderUrlWithNewQueryParams = (newQueryParams) => {
  const queryParams = QueryString.parse(window.location.search.substring(1));
  const { userLocation, search, ...restQueryParams } = queryParams;
  const params = {
    ...removeEmptyValues(restQueryParams),
    ...removeEmptyValues(newQueryParams)
  };
  const isEmptyParams = Object.keys(params).length === 0;
  return `${window.location.pathname}${QueryString.stringify(params, isEmptyParams)}`;
};
const replaceStoreFinderUrlWithNewQueryParams = (newQueryParams) => {
  window.history.replaceState(
    null,
    "store-finder",
    getStoreFinderUrlWithNewQueryParams(newQueryParams)
  );
};
export {
  areServicesAvailable,
  createBreadcrumbs,
  getBookAppointmentUrl,
  getStoreDetailUrl,
  getStoreFinderUrlWithNewQueryParams,
  isEqualStores,
  removeEmptyValues,
  replaceStoreFinderUrlWithNewQueryParams
};
//# sourceMappingURL=store-utils.js.map
